import React from 'react';
import LandingNav from './LandingNav';
import LandingFooter from './LandingFooter';
import SeoMeta from '../SeoMeta';
import './LandingPage.css';

const TermsOfService: React.FC = () => {
  return (
    <div className="landing-page">
      <SeoMeta
        title="Terms of Service — Map of Projects"
        description="Terms of service for Map of Projects."
        path="/terms"
      />
      <a href="#main-content" className="landing-skip-link">Skip to content</a>
      <LandingNav />

      <main id="main-content">
        <section className="legal-content">
          <p className="legal-content__eyebrow">Legal</p>
          <h1>Terms of Service</h1>
          <p className="legal-content__meta">Last updated: [DATE]</p>

          <p>[PLACEHOLDER — paste Terms of Service text here.]</p>
        </section>
      </main>

      <LandingFooter />
    </div>
  );
};

export default TermsOfService;
